module.exports = __webpack_public_path__ + "static/media/breadcrumb_resplogo.7c6340d3.svg";